// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NatureBackgrounds__image___VYEpO {
    left: 0;
    width: 100%;
    position: absolute;
    transition: all 2s;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `NatureBackgrounds__image___VYEpO`
};
module.exports = ___CSS_LOADER_EXPORT___;
